import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cursor = defineConnector({
  identifier: "cursor",
  name: "Cursor",
  tagLine: "AI code editor",
  keywords: "ai code editor ide anysphere admin api teams members usage",
  logo,
  protocol: "http",
  tags: ["engineering", "ai"],
  defaultUrlPattern: () => "https://api\\.cursor\\.com/.*",
  auth: (app) => basicAuth({ username: app.secret.apiKey, password: "" }),
  steps: [
    {
      title: "Create an admin API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Cursor dashboard](https://cursor.com/dashboard), open **API Keys** and create a new key. Only administrators of an Enterprise team can do this.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.cursor.com/teams/members",
  },
});
